'use client'

export interface FplPlayerCardProps {
  webName: string
  teamLogoUrl?: string | null
  teamColorHex?: string | null
  countryFlagUrl?: string | null
  points?: number | null
  isCaptain?: boolean
  isViceCaptain?: boolean
}

export function FplPlayerCard({
  webName,
  teamLogoUrl,
  teamColorHex,
  countryFlagUrl,
  points,
  isCaptain,
  isViceCaptain,
}: FplPlayerCardProps) {
  const color = teamColorHex || '#dc2626'
  return (
    <div className="flex flex-col overflow-hidden rounded-lg border border-white/10 bg-[#0e1114]">
      {/* Same muted-fill + solid-border treatment as the /players form chart bars,
          just applied per-team instead of per-outcome. */}
      <div
        className="relative flex h-14 shrink-0 items-center justify-center rounded-t-lg border p-1.5 sm:h-16 sm:p-2"
        style={{ backgroundColor: `${color}30`, borderColor: color }}
      >
        {teamLogoUrl ? (
          <img src={teamLogoUrl} alt="" className="size-8 object-contain sm:size-9" />
        ) : (
          <div className="size-8 sm:size-9" />
        )}
        {countryFlagUrl && (
          <img
            src={countryFlagUrl}
            alt=""
            className="absolute bottom-1 right-1.5 size-3.5 object-contain drop-shadow"
          />
        )}
      </div>

      <div className="border-x-2 border-t border-white/25 px-1.5 py-1 text-center">
        <p className="truncate text-[11px] font-semibold text-white">{webName}</p>
      </div>

      <div className="flex h-5 items-center justify-center gap-1 rounded-b-lg border-x-2 border-t-2 border-white/25 bg-[#0e1114] px-1.5">
        {isCaptain && <span className="text-xs font-bold text-amber-500">C</span>}
        {isViceCaptain && <span className="text-xs font-bold text-blue-600">V</span>}
        <p className="text-xs font-bold text-white">{points != null ? points : '-'}</p>
      </div>
    </div>
  )
}
